import { useTranslation } from 'react-i18next'
import {
  OnboardingStep,
  getUsSteps
} from 'pages/Onboarding/OnboardingRegion/UsRegion/us-region-config'
import { CountryAlpha2 } from 'generated/graphql'
import { MerchantApplicationData } from 'pages/Onboarding'

export const useOnboardingRegion = ({
  merchantApplication
}: {
  merchantApplication: MerchantApplicationData
}): OnboardingStep[] => {
  const { t } = useTranslation()

  const country =
    merchantApplication?.businessStructureDetails?.registeredBusinessAddress
      ?.country?.alpha2

  if (country === CountryAlpha2.Us) {
    return getUsSteps(t)
  }

  throw new Error('Wrong region')
}
